App.controller('ZochReportLifeListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaReportService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'branchService', 'monthsService', '$filter', '$interval', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaReportService, $timeout, $stateParams, Blob, FileSaver, branchService, monthsService, $filter, $interval) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_report';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Lista raportów';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    var page = 0;
    let deductionReportTimeout;
    let enteredReportTimeout;
    let generateReportInterval;
    $scope.pageSize = 8;
    $scope.currentDeduction = page;
    $scope.currentEntered = page;
    $scope.declarationStatus = 'ALL';

    const self = this;
    self.declarationStatus = 'ALL';
    self.selectedBranchDeduction = null;
    self.reportTypeDeclarations = 'ENTERED';
    self.selectedBranchDeclarations = null;

    self.month = null;
    self.year = null;

    $scope.additional = {
        forCompany: false
    };

    loadBranch();
    loadDeductionReports(page);
    loadEnteredReports(page);

    function loadDeductionReports(page) {
        var criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize
        };
        zochaReportService.dataLifeDeductionReportList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.deductions = data.data.data;
                $scope.numberOfPagesDeduction = data.data.pages;
            }
        });
    }

    function loadEnteredReports(page) {
        var criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize
        };
        zochaReportService.dataLifeEnteredReportList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.entereds = data.data.data;
                $scope.numberOfPagesEntered = data.data.pages;
            }
        });
    }

    $scope.pageDeductionChanged = function (page) {
        loadDeductionReports(page);
        $scope.currentDeduction = page;
    };

    $scope.pageEnteredChanged = function (page) {
        loadEnteredReports(page);
        $scope.currentEntered = page;
    };

    $scope.getDeductionReport = function(ev, id, method) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        var format = (method === 'excel') ? '.xlsx' : '.csv';
        var name = 'raport_' + id + format;
        var type = (method === 'excel') ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv';

        var criteria = {
            id: id,
            method: method
        };
        zochaReportService.getLifeDeductionReport(criteria).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], { type: type });
                FileSaver.saveAs(data, name);
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

    $scope.getEnteredReport = function(ev, id, method) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        var format = (method === 'excel') ? '.xlsx' : '.csv';
        var name = 'raport_' + id + format;
        var type = (method === 'excel') ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv';

        var criteria = {
            id: id,
            method: method
        };
        zochaReportService.getLifeEnteredReport(criteria).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], { type: type });
                FileSaver.saveAs(data, name);
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

    $scope.generateDeduction = function() {
        var vm = this;

        var el = $(vm.formDeduction.$$element[0]).find('button[type="submit"]');

        if (!vm.formDeduction.$valid) {
            return 0;
        }

        if (el.hasClass('disabled')) {
            return 0;
        } else {
            el.addClass('disabled');
        }

        $scope.data = {
            declarationStatus: self.declarationStatus,
            month: self.month,
            year: self.year
        };

        if ($scope.additional.forCompany) {
            $scope.data.company = {
                id: Config.COMPANY_ID
            }
        } else {
            $scope.data.branch = {
                id: self.selectedBranchDeduction.id
            }
        }

        zochaReportService.generateLifeDeductionReport($scope.data).then(function (data) {
            if (data.status === 200) {
                loadDeductionReports(0);
            }

            deductionReportTimeout = $timeout(function() {
                el.removeClass('disabled');
                loadDeductionReports(0);
            }, 1500);
        });
    };

    $scope.generateEntered = function() {
        var vm = this;

        var el = $(vm.formDeclarations.$$element[0]).find('button[type="submit"]');

        if (!vm.formDeclarations.$valid) {
            return 0;
        }

        if (el.hasClass('disabled')) {
            return 0;
        } else {
            el.addClass('disabled');
        }

        $scope.data = {
            branch: {
                id: self.selectedBranchDeclarations.id,
            },
            type: self.reportTypeDeclarations
        };

        zochaReportService.generateLifeEnteredReport($scope.data).then(function (data) {
            if (data.status === 200) {
                loadEnteredReports(0);
            }

            enteredReportTimeout = $timeout(function() {
                el.removeClass('disabled');
                loadEnteredReports(0);
            }, 1500);
        });
    };

    monthsService.dataMonthsList().then(function (data) {
        $scope.months = data.data.data;
        $scope.years = years();

        setNow();
    });

    function setNow() {
        var now = $filter('nowYearAndMonth')('');
        self.year = now.year;
        self.month = now.month;
    }

    function years() {
        var years = [];
        var startYear = 2018;
        var now = $filter('nowYearAndMonth')('');

        while (startYear <= now.year + 2) {
            years.push(startYear);
            startYear++;
        }

        return years;
    }

    function loadBranch() {
        branchService.dataZochBranchLists().then(function (data) {
            $scope.branch = data.data.data;
            self.selectedBranchDeduction = $scope.branch[0];
            self.selectedBranchDeclarations = $scope.branch[0];
        });
    }

    // ##### FILTER ##### //
    $scope.querySearchBranch = function(query) {
        var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    }

    function expandMenuAfterReload() {
        var target = $('ul.menu.menu_5');
        if (!target) {
            return;
        }
        var h = target[0].scrollHeight;

        $(target).addClass('open');
        $('.sidebar').addClass('opened');
        $(target).velocity("stop", true).velocity({height: h})
    }

    $timeout(function (){
        expandMenuAfterReload();
    }, 500);


    generateReportInterval = $interval(function () {
        loadDeductionReports(page);
        loadEnteredReports(page);
    }, 60000);

    $scope.$on('$destroy', function() {
        if (angular.isDefined(deductionReportTimeout)) {
            $timeout.cancel(deductionReportTimeout);
            deductionReportTimeout = undefined;
        }
        if (angular.isDefined(enteredReportTimeout)) {
            $timeout.cancel(enteredReportTimeout);
            enteredReportTimeout = undefined;
        }
        if (angular.isDefined(generateReportInterval)) {
            $interval.cancel(generateReportInterval);
            generateReportInterval = undefined;
        }
    });
}]);
